import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import {Message} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 替换主题色
import '../src/css/element-variables.scss'
// 自定义css样式
import '../src/css/style.css';
// 引入字体图标
import '../src/assets/fontIcon/iconfont.css'
// 自定义全局组件
import TopBackground from '../src/components/secondTop.vue';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import  axios from 'axios'
import  VueAxios from 'vue-axios'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.component('TopBackground',TopBackground)

Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.use(VueAxios,axios)
Vue.prototype.$message = Message;
var localStorageMock = (function(win) {
    var storage = win.localStorage;
    return {
        setItem: function(key, value) {
            var setItemEvent = new Event("setItemEvent");
            var oldValue = storage[key];
            setItemEvent.key = key;
            // 新旧值深度判断，派发监听事件
            if (oldValue !== value) {
                setItemEvent.newValue = value;
                setItemEvent.oldValue = oldValue;
                win.dispatchEvent(setItemEvent);
                storage[key] = value;
                return true;
            }
            return false;
        },
        getItem: function(key) {
            return storage[key];
        },
        removeItem: function(key) {
            storage[key] = null;
            return true;
        },
        clear: function() {
            storage.clear();
            return true;
        },
        key: function (index) {
            return storage.key(index);
        }
    };
}(window));

Object.defineProperty(window, 'localStorage', { value: localStorageMock, writable: true });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
